import { Fragment, lazy, memo, useCallback, useEffect } from "react";
import { Route, Switch, useLocation, useRouteMatch } from "react-router-dom";
import { ConfigProvider, Grid } from "antd";
import MainApp from "./MainApp";
import { Routes } from "../../const";
import SignIn from "../../routes/SignIn";
import SSO from "../../containers/SSO";
import AuthRoute from "../../components/permission/routers/AuthRoute";
import { IntlProvider } from "react-intl";
import AppLocale from "../../lng-provider";
import localeTH from "antd/lib/locale/th_TH";
import { useDispatch, useSelector } from "react-redux";
import CentralModal from "../../components/Modal/CentralModal";
import useAuth from "../../components/hooks/useAuth";
import { MasterSelector } from "redux/selector";
import IntlMessages from "components/Message/IntlMessages";
import LoaderModal from "components/Modal/LoaderModal";
import Terminated from "containers/Terminated";
import RestrictionPage from "components/permission/RestrictionPage";
import LazyLoad from "components/LazyLoad";
import ErrorPage from "routes/ErrorPage";
import { useMount } from "components/hooks";
import { getConstants } from "redux/reducers/master";
import { push } from "connected-react-router";
import LimitPage from "routes/LimitPage";

const SuitabilityRequiredModal = LazyLoad(lazy(() => import("components/Modal/MncModal/SuitabilityRequiredModal")));

const App = () => {
  const dispatch = useDispatch();
  const authUser = useAuth();
  const location = useLocation();
  const match = useRouteMatch();
  const locale = useSelector(MasterSelector.locale);
  const breakpoint = Grid.useBreakpoint();

  useMount(() => {
    dispatch(getConstants());
  });

  useEffect(() => {
    if (location.pathname === "/") {
      dispatch(push(Routes.SignIn));
    }
  }, [authUser, location, dispatch]);

  const currentAppLocale = AppLocale[locale];

  const renderEmpty = useCallback(() => <IntlMessages id="global.not-found-data" />, []);

  return (
    <ConfigProvider locale={localeTH} renderEmpty={renderEmpty} componentSize={breakpoint.xl ? "middle" : "large"}>
      <IntlProvider locale={currentAppLocale.locale} messages={currentAppLocale.messages} textComponent={Fragment}>
        <LoaderModal>
          <Switch>
            <Route exact path={Routes.LimitPage} component={LimitPage} />
            <Route path={Routes.Error} component={ErrorPage} exact />
            <Route exact path={Routes.SignIn} component={SignIn} />
            <Route exact path={Routes.SSO} component={SSO} />
            <Route path={Routes.Terminated} component={Terminated} />
            <Route path={Routes.Restriction} component={RestrictionPage} />
            <AuthRoute path={`${match.url}`} location={location} component={MainApp} />
          </Switch>
          <CentralModal />
          <SuitabilityRequiredModal />
        </LoaderModal>
      </IntlProvider>
    </ConfigProvider>
  );
};

export default memo(App);
